import React from 'react';
import { CheckCircleIcon } from 'icons';
import { useTranslations } from 'next-intl';

import { Modal } from 'components';

interface IProps {
  onClose: () => void;
  open: boolean;
  title?: string;
  desc?: string;
}

const SuccessModal: React.FC<IProps> = ({ onClose, open, title, desc }) => {
  const t = useTranslations();

  return (
    <Modal
      footer={false}
      open={open}
      centered
      onClose={onClose}
      width="360px"
      closeIcon={false}
      styles={{
        content: { padding: '16px', borderRadius: '12px' }
      }}
    >
      <div className="flex flex-col items-center justify-center py-4">
        <CheckCircleIcon size="100" />
        <p className="mt-4 text-xl font-medium">{title || t('ariza_yuborildi')}</p>
        <p className="text-center text-sm text-gray-600">{desc || t('ariza_yuborildi_tavsif')}</p>
      </div>
    </Modal>
  );
};

export default SuccessModal;
